import { createAction } from '@ngrx/store';

export const enum BBoxActionTypes {
  trackConfirmedBooking = '[bbox] TRACK_CONFIRMED_BOOKING',
}

export const trackConfirmedBooking = createAction(
  BBoxActionTypes.trackConfirmedBooking,
);
